export default (function (w, d) {
    'use strict';

    function MiniCart() {
        this.initMiniCart();
    }

    MiniCart.prototype.initMiniCart = function () {
        $(document).on('click', '.mini-cart .remove', function(e) {
            e.preventDefault();
            var $this = $(this);
            var items_count = $this.parent().siblings().length + 1;

            $(this).parent().animate({
                'height': "0px",
                'padding': "0px"
            }, 500, function() {
                var product_id = $this.attr('data-id');
                var url = $this.attr('data-url');
                var home_url = $this.attr('data-home');

                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                });

                $.post(url, { product_id: product_id, from: 'minicart' }, function(response) {
                    $('.mini-cart-count').text('(' + response.total_cart_products + ')');
                    $('.mini-cart .price .amount').text(response.total_cart_sum);

                    if (response.total_cart_products <= 0) {
                        $('.mini-cart-count').addClass('d-none');
                        $('.products').addClass('d-none');
                        $('.no-products').removeClass('d-none');
                        $('.original-mini-cart-button').removeClass('active');
                        $('.mini-cart').removeClass('active');
                        $('.mini-cart .bottom-bar').removeClass('active');
                        $('body').removeClass('no-scroll-mobile');
                    }
                });

                $(this).remove();
            });
        });
    }

    return MiniCart;
}(window, document));

